import { progressColor } from './progressColor'
import styles from './ProgressReadonlyPill.module.css'

/** Farbig gefüllte, nicht editierbare Fortschrittsanzeige — für Felder, deren Wert sich
 * automatisch aus verknüpften Aufgaben/Checklisten ergibt statt manuell gepflegt zu werden. */
export function ProgressReadonlyPill({ value }: { value: number }) {
  return (
    <div className={styles.pill} style={{ background: `linear-gradient(to right, ${progressColor(value)} ${value}%, var(--surface-3) ${value}%)` }}>
      {value}%
    </div>
  )
}
